import { render, staticRenderFns } from "./PricingContent.vue?vue&type=template&id=7c40c69e&"
import script from "./PricingContent.vue?vue&type=script&lang=js&"
export * from "./PricingContent.vue?vue&type=script&lang=js&"
import style0 from "./PricingContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports